<template>
  <UserCommonLayout>
    <template #content>
      <LazyProSkillAssureSettingsListHeader />
      <LazyProSkillAssureSettingsListContent />
    </template>
  </UserCommonLayout>
</template>

<script setup lang="ts">
import {UserCommonLayout} from '#components';
import {useLoadingStore} from '~/store/loading/loadingStore';
import {useUserStore} from '~/store/user/userStore';

const loadingStore = useLoadingStore();
const userStore = useUserStore();
const { guard } = usePermissionGuard();

const handlerAssessmentMenuDoNotHavePermission = () => {
  if (!guard(
      userStore.isPermissionCreateAssessment ||
      userStore.isSuperAdminType
  )) return;
}

onMounted(() => {
  handlerAssessmentMenuDoNotHavePermission();
  loadingStore.closeLoading();
});
</script>

<style>
@import "~/assets/scss/business_style.scss";
</style>